import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core'
import { MediaObserver, MediaChange } from '@angular/flex-layout'
import { ChartPart } from 'src/app/models/chart.model'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-sp-chart-rank-items',
  template: `
    <mat-card>
      <mat-card-content>

        <div id="cd{{ chartName }}" class="chart-card-fold">

          <div
            fxLayout="row wrap"
            fxLayoutGap="8px"
            fxLayoutAlign="start center"
          >
            <input
              type="text"
              id="inp{{ chartName }}"
              class="input-text"
              readonly="true"
              value="{{ chartName }}"
            />

            <div fxFlex="1 1 auto"></div>

            @if (help) {
              <mat-icon class="help" [matTooltip]="help">
                help_outline
              </mat-icon>
            }

            @if (dataCollections) {
              <img
                class="datafix_icon"
                matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
                src="./assets/data_collections.png"
              />
            }
          </div>

          <div>
            @for (info of infos; track info) {
              <div class="chart-list">

                <div class="chart-subheader">
                  {{ info.chartNameJp }}
                </div>

                @for (rankingItem of info.chartItems; track rankingItem) {
                  <div class="ranking-row">

                    <mat-icon class="chart-icon">
                      {{ info.icon }}
                    </mat-icon>

                    <div class="ranking">
                      <span class="rank-number">
                        {{ rankingItem.currentRank }}
                      </span>
                      位
                    </div>

                    <div class="ranking-detail">

                      <div class="title">
                        {{ rankingItem.title }}
                      </div>

                      <div class="rank">
                        <span class="sp-prev-number">
                          （ 前週
                          {{
                            rankingItem.previousRank === null
                              ? '-'
                              : rankingItem.previousRank
                          }}
                          位、最高
                          {{ rankingItem.rankTop }}
                          位 ）
                        </span>
                      </div>

                      @if (rankingItem.creations_last_7_days) {
                        <div class="creations">
                          {{
                            'Creations ' +
                              (rankingItem.creations_last_7_days | number)
                          }}
                        </div>
                      }

                    </div>

                  </div>
                }

              </div>
            }
          </div>

        </div>

        <div fxLayoutAlign="center center">

          @if (infos.length > 1 || infos[0].chartItems.length > 1) {
            <button
              id="unfold{{ chartName }}"
              mat-icon-button
              class="unfold-button"
              matTooltip="展開"
              (click)="unfold()"
            >
              <mat-icon class="fold-icon">expand_more</mat-icon>
            </button>
          }

          @if (infos.length > 1 || infos[0].chartItems.length > 1) {
            <button
              id="fold{{ chartName }}"
              mat-icon-button
              class="fold-button"
              matTooltip="折畳"
              (click)="fold()"
            >
              <mat-icon class="fold-icon">expand_less</mat-icon>
            </button>
          }

        </div>

      </mat-card-content>
    </mat-card>
    
    
    `,
    styleUrls: ['./sp-chart-rank-items.component.scss'],
    standalone: false
})
export class SpChartRankItemsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = []

  constructor(public media: MediaObserver) {
    this.subscriptions.push(media.asObservable().subscribe(() => {}))
  }

  @Input()
  infos: ChartPart[]

  @Input()
  chartName: string

  @Input()
  help: string

  @Input()
  dataCollections: boolean

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach(it => it.unsubscribe())
  }

  unfold(): void {
    document
      .getElementById('cd' + this.chartName)
      .setAttribute('style', 'height: auto;overflow: auto;')
    document.getElementById('unfold' + this.chartName).style.display = 'none'
    document.getElementById('fold' + this.chartName).style.display = 'inline'
    document.getElementById('inp' + this.chartName).focus()
  }

  fold(): void {
    document
      .getElementById('cd' + this.chartName)
      .setAttribute('style', 'height: 160px;overflow: hidden;')
    document.getElementById('unfold' + this.chartName).style.display = 'inline'
    document.getElementById('fold' + this.chartName).style.display = 'none'
  }
}
